
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function TopTenants({ tenants, loading }: { tenants: any[], loading: boolean }) {
  if (loading) return <Skeleton className="h-[300px] w-full" />

  return (
    <Card className="border-slate-200 dark:border-slate-800 h-full">
      <CardHeader className="border-b pb-3 bg-muted/20">
        <CardTitle className="text-sm font-mono uppercase tracking-wider text-muted-foreground">Top Utilization</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y divide-slate-100 dark:divide-slate-800">
           {tenants.length === 0 ? (
              <div className="p-8 text-center text-muted-foreground text-xs font-mono">
                -- NO DATA --
              </div>
           ) : (
             // eslint-disable-next-line @typescript-eslint/no-explicit-any
             tenants.map((tenant: any, i: number) => (
               <div key={tenant.id} className="flex items-center gap-4 p-4 hover:bg-muted/30 transition-colors">
                 <span className="font-mono text-xs text-muted-foreground w-4">0{i + 1}</span>
                 <div className="flex-1 min-w-0">
                   <div className="flex justify-between items-baseline mb-1">
                     <span className="text-sm font-medium truncate">{tenant.name}</span>
                     <span className="text-xs font-mono text-muted-foreground">{tenant.usage} ops</span>
                   </div>
                   <div className="h-1.5 w-full bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                     <div 
                        className="h-full bg-slate-900 dark:bg-slate-100" 
                        style={{ width: `${tenant.usagePercent}%` }}
                      />
                   </div>
                 </div>
               </div>
             ))
           )}
        </div>
      </CardContent>
    </Card>
  )
}

export { TopTenants as DashboardTopTenants }
